export default "__VITE_ASSET__CBtwGHpk__"